import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import FireproofingHero from './components/FireproofingHero';
import FireproofingServices from './components/FireproofingServices';
import FireproofingTypesElPaso from './components/FireproofingTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import FireproofingFAQ from './components/FireproofingFAQ';

const Fireproofing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FireproofingHero />
      <FireproofingServices />
      <FireproofingTypesElPaso />
      <ContractorDirectory />
      <ComparisonChecklist />
      <FireproofingFAQ />
      <Footer />
    </div>
  );
};

export default Fireproofing;
